import React from "react"
import { Cell } from "fixed-data-table-2"
import moment from "moment"
import sheetConstants from "sheets/constants"

const DateAndTimeCell = ({ rowId, columnId, children, sheetId, columnIndex, editing, ...props }) =>
    <Cell {...props}>{children ? moment(children).local().format(sheetConstants.DATE_TIME_FORMAT) : undefined}</Cell>

export default DateAndTimeCell
